var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert",class:_vm.alertClass},[_vm._v(" "+_vm._s(_vm.alertMsg)+" "),_c('span',{staticClass:"close",on:{"click":function($event){$event.preventDefault();return _vm.dismiss()}}},[_vm._v("×")])])}
var staticRenderFns = []

export { render, staticRenderFns }